__turbopack_context__.v({
  "className": "headlinefont_3709cfba-module__EMWQYG__className",
});
